import { Link } from "react-router-dom";

/** Blok judul beranda saat banner utama belum diunggah. Dirender seketika (tanpa menunggu API). */
export function HeroJudul({ tagline }) {
  return (
    <section className="w-full px-4 md:px-0" data-testid="hero-judul">
      <div className="mx-auto w-full max-w-[1280px] bg-[#1D1D1F] px-6 py-10 text-white md:px-16 md:py-16">
        <h1 className="max-w-[820px] text-4xl font-semibold leading-tight sm:text-5xl lg:text-6xl">
          {tagline || "Spesialis Seal Induksi Aluminium dan Packaging"}
        </h1>
        <p className="mt-4 max-w-[560px] text-sm text-white/70 md:text-base">
          Diskon besar dan gratis ongkir untuk kebutuhan kemasan usaha Anda.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/katalog" data-testid="hero-judul-katalog"
            className="inline-flex h-11 items-center rounded-[2px] bg-[#FF6B1A] px-6 text-sm font-semibold text-white hover:opacity-90">
            Lihat Katalog
          </Link>
          <a href="https://wa.me/6287888806861" target="_blank" rel="noopener noreferrer"
            data-testid="hero-judul-whatsapp"
            className="inline-flex h-11 items-center rounded-[2px] border border-white/30 px-6 text-sm font-semibold text-white hover:bg-white/10">
            Chat WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
